
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.417 5.262a.75.75 0 01.75-.75H19a.75.75 0 01.589.285l3.5 4.434a.75.75 0 01.161.465v7a.75.75 0 01-.75.75h-2.358a2.702 2.702 0 01-5.189 0H8.475a2.702 2.702 0 01-5.188 0H1.5a.75.75 0 01-.75-.75v-3.917a.75.75 0 01.75-.75h10.917V5.262zm2.533 10.683a2.702 2.702 0 015.195 0h1.605v-4.1H18.3a.75.75 0 01-.738-.617l-.94-5.216h-2.705v9.933h1.033zm-6.45 0a.53.53 0 00-.022 0 2.702 2.702 0 00-5.194 0H2.25V13.53h10.167v2.416H8.5zm9.647-9.933l.78 4.333h2.823v-.39l-3.113-3.943h-.49zM5.881 15.49a1.201 1.201 0 100 2.402 1.201 1.201 0 000-2.402zm10.465 1.201a1.201 1.201 0 112.403 0 1.201 1.201 0 01-2.403 0z"}})])
          )
        }
      }
    